<!-- eslint-disable max-lines -->
<template>
    <div class="file-detail-subtab customer-subtab">
        <div class="file-detail-btn">
            <lots-button type="text" icon="el-icon-circle-check" size="medium"
                class="bigData-btn-detailPageStamperTabUse" v-has="authorityCode.subStamperUse"
                @click="handleUseStatus">启用</lots-button>
            <lots-button type="text" icon="el-icon-remove-outline" size="medium"
                class="bigData-btn-detailPageStamperTabStop" :loading="saveLoading" v-has="authorityCode.subStamperStop"
                @click="handleStopStatus">停用</lots-button>
            <lots-button type="text" icon="el-icon-refresh" size="medium" v-has="authorityCode.subStamperSync"
                @click="handleSync()" class="bigData-btn-detailPageStamperTabSync">同步</lots-button>
            <lots-button @click="openLink" v-has="authorityCode.subStamperLink"
                class="bigData-btn-detailPageStamperTabLink" type="text" size="medium" icon="el-icon-link">
                前往授权
            </lots-button>
        </div>
        <div class="file-detail-table">
            <edit-table-box class="prescreen" v-loading="subTabTable.tableLoading" ref="editTableBox"
                :selection="config.selection" :control="false" :columns="newColumns" :height="tableHeight"
                :tableData="subTabTable.totalData" :actions="config.actions" :editDisableRule="() => false"
                :allowRowClick="false" @selection-change="handleSelectedRow">
                <template #col-header="{ item }">
                    <span class="slot-box"
                        v-if="['stamperEmail', 'stamperMobile', 'stamperIdNumber'].includes(item.prop)">
                        <span>
                            {{ item.label }}
                        </span>
                        <img :class="['text-eyes', item.className]" @click.stop="handleChangeText(item)"
                            :src="encryption[item.prop] ? iconOpenEyes : iconCloseEyes" alt="">
                    </span>
                    <span v-else> {{ item.label }}</span>
                </template>
                <template v-slot:col-append="{ item, row, rIndex }">
                    <div v-if="['stamperEmail', 'stamperMobile', 'stamperIdNumber'].includes(item.prop)">
                        <span size="mini" type="text" class="mip-page-link no-wrap" :title="row[item.prop]">{{
                            encryptionHandle(row[item.prop] || '', item.prop)
                        }}</span>

                    </div>
                </template>
            </edit-table-box>
            <div class="footer">
                <lots-pagination @size-change="subTabTable.sizeChange" :current-page.sync="subTabTable.pageNo"
                    @current-change="subTabTable.pageChange" size="small"
                    layout="total, sizes, prev, pager, next, jumper" :total="subTabTable.pageTotal" />
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive, computed, watch } from '@vue/composition-api';
import editTableBox from '@/components/lots/editTableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import lotsButton from '@/components/lots/lotsButton';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import {
    updateStamperStatus,
    syncStamperStatus,
    getStamperInfoList
} from '@mdm/api/customer/customer.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { tableConfig } from './config.js';
import mConfig from '@/config/user.env';
import { Message, MessageBox } from 'element-ui';
import { STATE_OTHER_CHANGE } from '@/modules/mdm/constant/contractManage.js';
import bigDataLog from '@/utils/bigDataLog.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';

import _ from 'lodash';
export default {
    name: '',
    components: {
        lotsPagination,
        lotsButton,
        editTableBox
    },
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => { }
        },
        tableHeight: {
            type: Number,
            default: 325
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.customer);
        // const refs = setupContext.refs;
        const config = reactive(_.cloneDeep(tableConfig));
        const isDisableBtn = ref(false);
        const saveLoading = ref(false);
        class FilesDetailClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.customerCode = props.detailData.customerCode;
                return condition;
            };
            afterGetList(res) {
                if (+res.code === 0) {
                    res.data.list.forEach(item => {
                        item.edit = -3;
                    });
                    this.totalData.value = res.data.list;
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }
        const subTabTable = new FilesDetailClass({
            Api: {
                listApi: getStamperInfoList
            }
        });
        const newColumns = computed(() => {
            return config.columns;
        });
        const btnLoading = ref(false);
        const handleAddRow = () => {
            // refs.editTableBox.addRow();
            const newItem = {
                edit: 2,
                sealAdminName: undefined
            };
            subTabTable.totalData.value.unshift(newItem);
        };
        const handleSync = () => {
            if (!props.detailData.customerCode) {
                Message.warning('客户编码为空，不能同步盖章人信息。请核查客户信息，路径：LCRM-客户管理-客户详情');
                return;
            } else if (!props.detailData.customerName) {
                Message.warning('客户名称为空，不能同步盖章人信息。请核查客户信息，路径：LCRM-客户管理-客户详情');
                return;
            } else if (!props.detailData.societyCreditCode) {
                Message.warning('客户的社会信用代码为空，不能同步盖章人信息。请核查客户信息，路径：LCRM-客户管理-客户详情');
                return;
            }
            syncStamperStatus({
                customerCode: props.detailData.customerCode,
                customerName: props.detailData.customerName,
                societyCreditCode: props.detailData.societyCreditCode
            }).then(res => {
                if (res && +res.code === 0) {
                    Message.success('同步成功');
                }
            }).finally(() => {
                subTabTable.getList();
            });
        };
        const selections = ref([]); // 选中的行数组
        const handleSelectedRow = (selection) => {
            selections.value = selection;
        };
        const sealAdminKey = ref(false);
        const openLink = () => {
            window.open(mConfig.mSign, '_blank');
        };
        const handleUseStatus = () => {
            if (selections.value.length !== 1) {
                return Message.warning('请选择一条数据进行操作');
            };
            updateStamperStatus({
                customerCode: props.detailData.customerCode,
                id: selections.value[0].id,
                enableFlag: '1'
            }).then(res => {
                if (res && +res.code === 0) {
                    Message.success('启用成功');
                }
            }).finally(() => {
                subTabTable.getList();
            });
        };
        const handleStopStatus = () => {
            if (selections.value.length !== 1) {
                return Message.warning('请选择一条数据进行操作');
            };
            MessageBox.confirm(`确认停用当前选择的数据？`, `提示：`, {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateStamperStatus({
                    customerCode: props.detailData.customerCode,
                    id: selections.value[0].id,
                    enableFlag: '0'
                }).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('停用成功');
                    }
                }).finally(() => {
                    subTabTable.getList();
                });
            }).catch(() => { subTabTable.getList(); });
        };
        const encryption = ref({
            stamperEmail: false,
            stamperMobile: false,
            stamperIdNumber: false
        });
        const handleChangeText = (item) => {
            encryption.value[item.prop] = !encryption.value[item.prop];
            item.className && bigDataLog.sendDetailMessageByKey(item.className);
        };
        const menuList = {
            stamperEmail: 'email',
            stamperMobile: 'mobile',
            stamperIdNumber: 'idCard'
        };
        const encryptionHandle = (val, p) => {
            const prop = menuList[p];
            const { desensitization } = otherUtils;
            if (!desensitization[prop]) return '';
            if (encryption.value[p]) return val;
            return desensitization[prop](val);
        };
        watch(
            () => [props.activeName],
            // eslint-disable-next-line complexity
            (newVal) => {
                if (newVal[0] === 'stamper') {
                    if (newVal[0]) {
                        subTabTable.getList();
                    } else {
                        subTabTable.totalData.value = [];
                        subTabTable.pageTotal.value = 0;
                    }
                    bigDataLog.sendDetailMessageByKey('bigData-page-detailPageStamperTab');
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            config,
            subTabTable,
            btnLoading,
            isDisableBtn,
            saveLoading,
            authorityCode,
            STATE_OTHER_CHANGE,
            newColumns,
            sealAdminKey,
            encryption,
            iconCloseEyes,
            iconOpenEyes,
            encryptionHandle,
            handleChangeText,
            handleAddRow,
            handleSync,
            handleSelectedRow,
            openLink,
            handleStopStatus,
            handleUseStatus
        };
    }
};
</script>
<style lang="less" scoped>
.text-eyes {
    width: 14px;
    margin-left: 4px;
    cursor: pointer;
    position: relative;
    top: 2px;
}
</style>
<style lang="less">
.customer-subtab {
    .file-detail-btn {
        width: 100%;
        display: flex;
        align-items: center;

        .sub-tab-search-box {
            flex: 1;
            height: 28px;
            margin: 0 0 0 30px;

            .search-box {
                &>div>button.search-btn {
                    height: 24px;
                    min-height: 24px;
                    padding: 2px 4px;
                    margin-top: 2px;
                    /* background-color: #4285F5;
                    border-color: #4285F5; */
                }

                .search {

                    .el-input-group__append,
                    .el-input-group__prepend {
                        padding: 0 14px;
                    }
                }
            }
        }
    }
}
</style>
